import { Paper, Box, Typography, Button, Alert } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  addNegotiationDetails,
  getNegotiationDetails,
  confirmNegotiation,
} from "../../api/caseNegotiations";
import ConditionalRenderer from "../../components/ConditionalRenderer";
import useCustomAlert from "../../hooks/useCustomAlert";
import useSnackbar from "../../hooks/useSnackbar";
import useErrorHandler from "../../hooks/useErrorHandler";

const tempNeg = {
  id: 11,
  title: "Title",
  description: "Description",
  start_amount: 0,
  latest_amount: 0,
  creator_name: "",
  updated_at: new Date().toISOString(),
  status: "CLOSED",
  creator_id: 1,
  case_id: 1,
  created_at: new Date().toISOString(),
};

function toUSD(money) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(money);
}

export default function NegotiationDetails() {
  const [details, setDetails] = useState([]);
  const [neg, setNeg] = useState(tempNeg);
  const [latestNeg, setLatestNeg] = useState({
    id: 1,
    neg_id: 1,
    creator_id: 1,
    amount: 0,
    text: "",
    created_at: "",
    creator_name: "",
  });
  // const latestNeg = details[details.length - 1];

  const [loading, setLoading] = useState(true);
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const snackbar = useSnackbar();
  const navigation =useNavigate()
  const errorHandler = useErrorHandler();
  const [counterNeg, setCounterNeg] = useState({
    neg_id: params.negId,
    amount: "",
    text: "",
  });
  const [isPrimary, setIsPrimary] = useState(false);
  function onCounterNegChange({ target }) {
    setCounterNeg((prev) => ({ ...prev, [target.name]: target.value }));
  }

  async function onCounterNegSubmit(e) {
    e.preventDefault();
    try {
      const { data } = await addNegotiationDetails(
        user.token,
        params.caseId,
        counterNeg
      );
      const newId = data.newDetailId;

      setNeg((prev) => ({ ...prev, latest_amount: counterNeg.amount }));
      setDetails((prev) => [
        ...prev,
        {
          id: newId,
          neg_id: counterNeg.neg_id,
          creator_id: user.id,
          amount: counterNeg.amount,
          text: counterNeg.text,
          created_at: new Date().toISOString(),
          creator_name: `${user.firstname} ${user.lastname}`,
        },
      ]);
      setLatestNeg({
        id: newId,
        created_at: new Date().toISOString(),
        amount: counterNeg.amount,
        creator_id: user.id,
        text: counterNeg.text,
        creator_name: `${user.firstname} ${user.lastname}`,
      });
      setCounterNeg({ neg_id: params.negId, amount: "", text: "" });
      snackbar.showSuccess("New Offer Posted");
    } catch (error) {
      console.log(error);
      snackbar.showError();
    }
  }

  async function getNegotiationDetailsData() {
    getNegotiationDetails(user.token, params.caseId, params.negId)
      .then(({ data }) => {
        const { negotiation, details, primary } = data.data;
        setIsPrimary(primary);
        setNeg(negotiation);
        setDetails(details);
        if (details.length) {
          setLatestNeg(details[details.length - 1]);
        } else {
          setLatestNeg({
            id: negotiation.id,
            created_at: negotiation.created_at,
            amount: negotiation.latest_amount,
            creator_id: negotiation.creator_id,
            text: negotiation.description,
            creator_name: negotiation.creator_name,
          });
        }
      })
      .catch((error) => {
        errorHandler(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (!user.token) return;
    getNegotiationDetailsData();
  }, [params.caseId, params.negId, user.token]);

  const customAlert = useCustomAlert();
  function onConfirmClick() {
    customAlert.info(
      `Confirm and settle for ${toUSD(latestNeg.amount)}`,
      onAgree
    );
  }
  const onAgree = async () => {
    try {
      await confirmNegotiation(user.token, params.caseId, params.negId);
      snackbar.showSuccess("Confirmed");
      getNegotiationDetailsData();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
 
          <Box p={2} display="flex" justifyContent="space-between">
             
              <Box display="flex" justifyContent="flex-end" columnGap={2}>
              <Button
                onClick={()=>navigation(-1)}
                  variant="contained"
                  size="large"
                  color="primary"
                  className="blue-button"
                  fullWidth
                >
                 Go Back
                </Button>
              </Box>
            </Box>
      <Paper className="odr-card" sx={{ p: 2 }}>
        
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Typography component="h5" fontWeight={500}>
              {neg.title}
            </Typography>
            <Typography component="p" fontSize="small">
              {neg.description}
            </Typography>
          </Box>
          {neg.status === "CLOSED" ? (
            <Box>
              <Alert severity="warning">
                CLOSED: Settled For {toUSD(neg.latest_amount)}
              </Alert>
            </Box>
          ) : (
            <Box display="flex" columnGap={1} alignItems="center">
              <Typography>{toUSD(latestNeg.amount)}</Typography>
              {latestNeg?.creator_id !== user.id ? (
                <ConditionalRenderer show={/true/.test(isPrimary)}>
                  <Button
                    size="large"
                    onClick={onConfirmClick}
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    className="blue-button"
                    disabled={/^trial_user$/i.test(user.roles) ? true : false}
                  >
                    Agree & Confirm
                  </Button>
                </ConditionalRenderer>
              ) : (
                <></>
              )}
            </Box>
          )}
        </Box>
        <Box
          mt={2}
          p={1}
          border="1px solid #D5DDD5"
          borderRadius={1}
          backgroundColor="#D8E9F0"
        >
          <Typography textAlign="center">
            {new Date(neg.created_at).toLocaleString()} : {neg.creator_name}{" "}
            Opened negotiation for a sum of {toUSD(neg.start_amount)}
          </Typography>
        </Box>
      </Paper>
      <Box maxHeight="50vh" mt={2} sx={{ overflowY: "scroll" }}>
        {details.map((d, i) => (
          <DetailCard data={d} user={user} key={i} />
        ))}
      </Box>
      {neg.status !== "CLOSED" &&
      latestNeg?.id &&
      latestNeg?.creator_id !== user.id ? (
        <ConditionalRenderer show={/true/.test(isPrimary)}>
          <Paper>
            <Box
              component="form"
              onSubmit={onCounterNegSubmit}
              display="flex"
              justifyContent="flex-end"
              p={1}
              columnGap={1}
            >
              <input
                type="number"
                placeholder="Amount($)"
                required
                name="amount"
                value={counterNeg.amount}
                onChange={onCounterNegChange}
              />
              <input
                placeholder="Say Something"
                name="text"
                value={counterNeg.text}
                onChange={onCounterNegChange}
              />

              <Button
                size="large"
                type="submit"
                variant="contained"
                disabled={/^trial_user$/i.test(user.roles) ? true : false}
              >
                Send
              </Button>
            </Box>
          </Paper>
        </ConditionalRenderer>
      ) : (
        <></>
      )}
    </>
  );
}

function DetailCard({ data, user }) {
  return (
    <Box py={1} display="flex">
      <Paper
        elevation={2}
        sx={{
          width: "30%",
          maxWidth: "40%",
          marginLeft: data.creator_id === user.id ? "auto" : 0,
        }}
      >
        <Box sx={{ px: 1, backgroundColor: "#ededed" }}>
          <Typography fontSize="small">{data.creator_name}</Typography>
        </Box>
        <Box p={1}>
          <Typography variant="h4">{toUSD(data.amount)}</Typography>
        </Box>
        <Box p={1}>
          <Typography>{data.text}</Typography>
        </Box>
      </Paper>
    </Box>
  );
}
